import { createSlice } from "@reduxjs/toolkit";

const cancellationFilterSlice = createSlice({
  name: "cancellationFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const { setStatusFilter, setSearchFilter, clearSearchFilter } =
  cancellationFilterSlice.actions;

export const selectCancellationState = (state) => state.cancellationFilter;

export default cancellationFilterSlice.reducer;
